import { useSelector } from 'react-redux';
import { selectUserRole } from 'pages/Profile/selectors';
import { Roles } from 'constants/roles';

export const useRole = () => {
  const role = useSelector(selectUserRole);

  return {
    userRole: role,
    userRoleName: Roles.getRoleName(role),
    isAdminRole: role === Roles.Admin,
    isBoRole: role === Roles.BO,
    isSoRole: role === Roles.SO,
    isOwnerRole: role === Roles.Owner,
    isReporterRole: role === Roles.Reporter,
    isViewerRole: role === Roles.Viewer,
    isBoSoRole: role === Roles.BO || role === Roles.SO,
    isRestrictedBoSoViewerRole: role === Roles.BO || role === Roles.SO || role === Roles.Viewer,
  };
};
